@if (dateRangeForm) {
  @if (!showRangeOptions) {
    @if (rangeOption === 'custom') {
      <mat-form-field (click)="openOptionsPicker()" [appearance]="appearance" [class.header]="header" [disabled]="disabled">
        @if (label) {
          <mat-label class="vertical-align-center">
            <tidy-text [body]="label" />
          </mat-label>
        }
        <mat-date-range-input [rangePicker]="picker" #dateRangeInput [disabled]="disabled">
          <input #startDateInput matStartDate [formControl]="dateRangeForm.controls.start">
          <input matEndDate [formControl]="dateRangeForm.controls.end"(dateChange)="emitOptionChange()">
        </mat-date-range-input>
        <tidy-image
          [src]="'assets/svg/caret-down.svg'"
          class="caret-icon" />
        <mat-date-range-picker #picker />
      </mat-form-field>
    }
    @if (rangeOption !== 'custom') {
      <mat-form-field (click)="openOptionsPicker()" [appearance]="appearance" [class.header]="header" [disabled]="disabled">
        @if (label) {
          <mat-label class="vertical-align-center">
            <tidy-text [body]="label" />
          </mat-label>
        }
        <mat-select [formControl]="dateRangeForm.controls.customStringSelect" [disabled]="disabled">
          @for (option of selectOptions; track option) {
            <mat-option [value]="option.value">{{option.viewValue| translate}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }
  @if (showRangeOptions) {
    <mat-form-field [appearance]="appearance" [class.header]="header" [disabled]="disabled">
      @if (label) {
        <mat-label class="vertical-align-center">
          <tidy-text [body]="label" />
        </mat-label>
      }
      <mat-select #optionsPicker (selectionChange)="selectOption($event.value)" [formControl]="dateRangeForm.controls.customStringSelect" [disabled]="disabled">
        @for (option of selectOptions; track option) {
          <mat-option [value]="option.value">{{option.viewValue | translate}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @if (!dateRangeForm.valid && submitted) {
    <tidy-error-message [text]="errorMessage" />
  }
}
